import axios from 'axios'
import interceptorsSetup from '@/helpers/interceptors'

const baseURL = process.env.VUE_APP_API_URL_V3 + '/actionPlan'

const actionPlanAPI = axios.create({
  baseURL
})

interceptorsSetup(actionPlanAPI)

export default class ActionPlan {
  static async getTable (actionPlanQuery) {
    const result = await actionPlanAPI.get('/' + actionPlanQuery.siteId, {
    })
    return result.data
  }
  static async createActionPlan (actionPlan) {
    const result = await actionPlanAPI.post('/', actionPlan)
    return result.data
  }
  static async updateActionPlan (actionPlan) {
    const result = await actionPlanAPI.post('/update', actionPlan)
    return result.data
  }
  static async archiveActionPlan (actionPlan) {
    const result = await actionPlanAPI.put('/archive/' + actionPlan)
    return result.data
  }
}
